// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__oYeBD","company":"Footer_company__DOPAf","actions":"Footer_actions__jNx3S","action":"Footer_action__YaTF3"};